import {
  Permission,
  PermissionAction,
  PermissionResourceType,
} from 'src/constants/permissions';

export const hasPermission = (
  permissions: Permission[],
  action: PermissionAction,
  resourceType: PermissionResourceType,
  resource: string
) =>
  permissions.some((permission) => {
    const hasAction =
      permission.action === PermissionAction.ALL ||
      permission.action === action;
    const hasResourceType =
      permission.resource_type === PermissionResourceType['*'] ||
      permission.resource_type === resourceType;
    const hasResource = permission.resource.some(
      (res) => res === '*' || res === resource
    );
    return hasAction && hasResourceType && hasResource;
  });
